<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">

      <div class="searchTitle display_between">
        <div class="searchTitleText">
          期刊浏览
        </div>
        <div class="searchInput">
          <img src="/image/icon/fangdajinghui.png">
          <input type="text"
                 name=""
                 id=""
                 value="" />
        </div>
      </div>
      <div class="positionBtn marginBottom40">
        <swiper :options="swiperOption"
                ref="mySwiper"
                class="imgBanner">
          <swiper-slide v-for="(item,index) in yearList"
                        :key="'0'+index">
            <a href="javascript:;"
               :class="{timeItem_active:yearTagindex==index}"
               class="timeItem"
               @click="yearClick(item,index)">
              {{item.nian}}
            </a>
          </swiper-slide>
        </swiper>
        <div class="prevbutton">&lt;</div>
        <div class="nextbutton">&gt;</div>
      </div>
      <div class="listNews"
           v-for="(nitem,index) in contentlist"
           :key="'1'+index"
           @click="ClickIssueList(nitem)">
        <img src="/image/icon/lv14.png"
             class="listNewsActive">
        <a href="javascript:;">
          <span class="date">{{formatTime(nitem.chubanriqi,'YYYY/MM/DD')}}</span>
          <span class="intro_text">{{nitem.nian}}&nbsp;vol.{{nitem.juan}}&nbsp;No.{{nitem.qi}}&nbsp;pp.{{nitem.startPage}}-{{nitem.endPage}}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage'
import format from '@/assets/unit/unit.js'
export default {
  name: 'litelist',
  data () {
    return {
      apiData: {
        yearNum: {},
        news: {},
      },

      // 年份激活index
      yearTagindex: 0,
      swiperOption: {
        slidesPerView: 12,
        slidesPerGroup: 12,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled',
        },
      },
      /**tianlianpei */
      activeNames: '',
      yearList: [],
      periodicalList: [],
      contentlist: [],
    }
  },
  components: {
    breadcrumbPage,
  },
  created () {

    this.GetPeriodicalBrowsePageList()
  },
  methods: {
    // 年份点击
    yearClick (year, index) {
      this.yearTagindex = index
      // 根据年份year获取数据
      this.contentlist = []
      this.contentlist = this.periodicalList.filter(function (item) {
        return item.nian == year.nian
      })
    },
    GetPeriodicalBrowsePageList () {
      let _this = this
      _this.httphelper
        .get('/api/ArticleApi/GetPeriodicalBrowsePageList')
        .then((res) => {
          if (res.code == 200) {
            _this.periodicalList = res.data
            _this.yearList = this.unique(res.data)
            _this.contentlist = _this.periodicalList.filter(
              function (item) {
                return item.nian == _this.yearList[0].nian
              }
            )
          }
        })
    },
    unique (arr) {
      const res = new Map()
      return arr.filter(
        (arr) => !res.has(arr.nian) && res.set(arr.nian, 1)
      )
    },
    ClickIssueList (item) {
      this.$router.push({
        path: '/journal/magazinejournal',
        query: {
          nian: item.nian,
          qi: item.qi,
        },
      })
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat)
    },
  },
}
</script>

<style scoped>
.content {
    padding-top: 20px;
    flex: 1;
    padding-bottom: 40px;
}

.searchTitle {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
}
.searchTitleText {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #333;
}
.searchInput {
    position: relative;
}
.searchInput img {
    position: absolute;
    left: 10px;
    top: 23px;
}
.searchInput input {
    height: 30px;
    border: none;
    background: #ebebeb;
    width: 226px;
    outline: none;
    border-radius: 5px;
    padding-left: 30px;
    box-sizing: border-box;
}
.timeLine {
    height: 100px;
    line-height: 100px;
}
.page_btn {
    color: #999;
    cursor: pointer;
    display: inline-block;
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border-radius: 30px;
    border: 1px solid #ccc;
}
.page_btn_active {
    background: #0b8686;
    color: #fff;
    border: 1px solid #0b8686;
}
.timeItem {
    width: 66px;
    height: 66px;
    border-radius: 66px;
    font-size: 18px;
    text-align: center;
    line-height: 66px;
    font-weight: bold;
    display: inline-block;
    color: #333;
}
.timeItem_active {
    background: linear-gradient(90deg, #3a9a9b, #007476);
    color: #fff;
}
.listNews {
    padding-left: 66px;
    margin-bottom: 14px;
    margin-top: 14px;
    height: 36px;
    line-height: 36px;
    position: relative;
}

.date {
    color: #ccc;
    font-size: 14px;
    margin-right: 20px;
}
.intro_text {
    color: #333;
    font-size: 14px;
}
.listNews:hover {
    background: #f5f8fa;
}
.listNewsActive {
    display: none;
    position: absolute;
    left: 10px;
    top: 12px;
}
.listNews:hover .listNewsActive {
    display: block;
}
/* 设置底部轮播  注意顺序 positionBtn*/
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1240px;
}

.nextbutton,
.prevbutton {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 28%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton {
    right: -30px;
    left: auto;
}

.prevbutton {
    right: auto;
    left: -30px;
}
.swiper-slide {
    text-align: center;
}
.my-button-disabled {
    background: #ddd;
    color: #999;
}
</style>
